import { render } from "./UiSearchInput.vue?vue&type=template&id=6a81971b"
import script from "./UiSearchInput.vue?vue&type=script&lang=js"
export * from "./UiSearchInput.vue?vue&type=script&lang=js"

import exportComponent from "D:\\laragon\\www\\leader-main\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__